import { render, staticRenderFns } from "./pendingOrder.vue?vue&type=template&id=5e006f37&scoped=true"
import script from "./pendingOrder.vue?vue&type=script&lang=js"
export * from "./pendingOrder.vue?vue&type=script&lang=js"
import style0 from "./pendingOrder.vue?vue&type=style&index=0&id=5e006f37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e006f37",
  null
  
)

export default component.exports